/* eslint-disable no-undef */
import React, { Component } from "react";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Api from "../../../../../Services/Api";
import DDLPositionJob from '../../../../../modules/commons/DDLPositionJob';
import DDLPositionLevel from '../../../../../modules/commons/DDLPositionLevel';

class FormJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                roleJobId: "",
                roleId: "",
                companyId: "",
                jobId: "",
                levelId: "",
                status: "Active",
                action: "NEW"
            },
            jobData: [],
            levelData: [],
            disabledDdlJob: false,
            loadSave: false,
        }
    }

    componentDidMount() {
        // this.getJobDdl();
        // this.getLevelDdl();
        this.setState({
            data: {
                ...this.state.data,
                roleId: this.props.data.roleId,
                companyId: this.props.data.companyId
            }
        })
    }

    // getJobDdl() {
    //     let payload = {
    //         companyId: this.props.data.companyId,
    //     }
    //     Api.create('MASTERDATA_EKSAD').postGetJobDdl(payload).then(
    //         (res) => {
    //             if (res.ok && res.data.status === 'S') {
    //                 let array = [{ value: "ALL", label: "ALL" }]
    //                 res.data.data && res.data.data.map((item) => {
    //                     array.push({
    //                         value: item.jobId,
    //                         label: item.jobTitle
    //                     })
    //                 })
    //                 this.setState({
    //                     jobData: array
    //                 })
    //             }
    //         })
    // }

    // getLevelDdl() {
    //     let payload = {
    //         companyId: this.props.data.companyId,
    //     }
    //     Api.create('MASTERDATA_EKSAD').postGetLevelDdl(payload).then(
    //         (res) => {
    //             if (res.ok && res.data.status === 'S') {
    //                 let array = [{ value: "ALL", label: "ALL" }]
    //                 res.data.data && res.data.data.map((item) => {
    //                     array.push({
    //                         value: item.levelId,
    //                         label: item.description
    //                     })
    //                 })
    //                 this.setState({
    //                     levelData: array
    //                 })
    //             }
    //         })
    // }

    // onChangeCombo = (event, name) => {
    //     let value = event.value;
    //     console.log(value)
    //     this.setState({
    //         data: { ...this.state.data, [name]: value }
    //     }, () => {
    //         if (name === "levelId" && value === "ALL") {
    //             let dataJob = {
    //                 value: value,
    //                 label: value
    //             }
    //             this.setState({
    //                 disabledDdlJob: true,
    //                 jobIdSelect: dataJob,
    //                 data: {
    //                     ...this.state.data,
    //                     jobId: value
    //                 },
    //             })
    //         }

    //         if (name === "levelId" && value !== "ALL") {
    //             this.setState({
    //                 disabledDdlJob: false,
    //                 jobIdSelect: "",
    //                 data: {
    //                     ...this.state.data,
    //                     jobId: ""
    //                 },
    //             })
    //         }

    //         if (name === "jobId") {
    //             let dataJob = {
    //                 value: value,
    //                 label: event.label
    //             }
    //             this.setState({
    //                 jobIdSelect: dataJob,
    //             })
    //         }
    //     });
    // }

    isLoad(visible) {
        this.setState({ loadSave: visible })
    }

    validation = (data) => {
        // console.log(JSON.stringify(this.state.data, null, 2))
        if (!data.jobId) {
            return alert('Job is Required.')
        } else if (!data.levelId) {
            return alert('Level is Required.')
        } else {
            this.isLoad(true);
            this.onClickSave();
        }
    }

    onClickSave = () => {
        Api.create('MASTERDATA_EKSAD').postSaveRoleMemberJob(this.state.data).then(
            (res) => {
                if (res.ok && res.data.status === 'S') {
                    this.isLoad(false);
                    this.props.onClickClose();
                    this.props.onClickSave(res);
                }
            })
    }

    render() {
        return (
            <div>
                <div className="app-popup app-popup-show">
                    <div className="padding-top-20px" />
                    <div className="popup-content background-white border-radius" style={{ width: "400px" }}>
                        <div className="popup-panel grid grid-2x">
                            <div className="col-1">
                                <div className="popup-title">
                                    {"Form Job"}
                                </div>
                            </div>
                            <div className="col-2 content-right">
                                <button
                                    className="btn btn-circle btn-grey"
                                    onClick={this.props.onClickClose}
                                >
                                    <i className="fa fa-lg fa-times" />
                                </button>
                            </div>
                        </div>
                        <div className="border-bottom padding-15px grid grid-1x grid-mobile-none gap-15px">
                            <div className="column-1">
                                {this.renderForm()}
                            </div>
                        </div>

                        <div className="padding-15px">
                            <div className="grid grid-2x">
                                <div className="col-1" />
                                <div className="col-2 content-right">
                                    {
                                        this.props.type !== 'view' &&
                                        <button className="btn btn-red" type="submit"
                                            disabled={this.state.loadSave}
                                            onClick={
                                                () => {
                                                    this.validation(this.state.data)
                                                }}
                                        >
                                            <span>{!this.state.loadSave ? 'SAVE' : 'Saving...'}</span>
                                        </button>
                                    }
                                    <button
                                        style={{ marginLeft: "15px" }}
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={this.props.onClickClose}
                                    >
                                        <span>CANCEL</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderForm() {
        return (
            <div>
                <DDLPositionJob
                    box={'search'}
                    label={'Job'}
                    mandatory={'true'}
                    all={true}
                    companyId={this.state.data.companyId}
                    onChangeCombo={(value) => {
                        this.setState({
                            data: {
                                ...this.state.data,
                                ...value,
                                levelId: value.jobId === "ALL" ? "ALL" : null,
                                levelIdSelect: value.jobId === "ALL" ? { value: "ALL", label: "All Level" } : [],
                            }
                        })
                    }}
                    valueCombo={this.state.data.jobIdSelect}
                    disabled={this.props.type === 'view'}
                />
                <DDLPositionLevel
                    box={'search'}
                    label={'Level'}
                    mandatory={'true'}
                    all={true}
                    jobId={this.state.data.jobId}
                    companyId={this.state.data.companyId}
                    onChangeCombo={(value) => {
                        this.setState({
                            data: {
                                ...this.state.data,
                                ...value,
                            }
                        })
                    }}
                    valueCombo={this.state.data.levelIdSelect}
                    disabled={this.props.type === 'view' || this.state.data.jobId === "ALL"}
                />
            </div>
        )
    }
}

export default FormJob;